module.exports = __webpack_public_path__ + "img/part4-uIcon3.4fd80206.png";